// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".layout-wrapper-top-bar .info-top-bar{left:0!important}.layout-wrapper-top-bar .info-top-bar .collapse-menu-icon{display:block!important}.el-notification .el-icon-info{color:#2196f3}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
